import axios from 'axios';

/**
 * Public axios instance for unauthenticated requests
 * Use this for public endpoints like contact form submission, fetching communities list, etc.
 */
const publicAxios = axios.create({
    baseURL: process.env.REACT_APP_API_BASE_URL,
    timeout: parseInt(process.env.REACT_APP_API_TIMEOUT || '10000', 10),
    headers: {
        'Content-Type': 'application/json',
    },
});

export default publicAxios;
